"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUSINESS_UNIT_JOBS_URL = exports.BUSINESS_UNIT_PUBLIC_APP_URL = exports.buildBrandingEmail = exports.BUSINESS_UNIT_EMAIL_DOMAIN = exports.getBrandingLabel = exports.BUSINESS_UNIT_BRAND = void 0;
exports.BUSINESS_UNIT_BRAND = {
    FR: 'IZIWORK',
    IT: 'IZIWORK',
    PM: 'PROMAN',
    PSTF: 'PROMAN_STAFFING',
};
const formatBrandLabel = (brand) => brand
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
const getBrandingLabel = (businessUnit) => formatBrandLabel(exports.BUSINESS_UNIT_BRAND[businessUnit]);
exports.getBrandingLabel = getBrandingLabel;
exports.BUSINESS_UNIT_EMAIL_DOMAIN = {
    FR: 'iziwork.com',
    IT: 'iziwork.com',
    PM: 'interim.proman-solutions.fr',
    PSTF: 'iziwork.com',
};
const buildBrandingEmail = (prefix, businessUnit) => `${prefix}@${exports.BUSINESS_UNIT_EMAIL_DOMAIN[businessUnit]}`;
exports.buildBrandingEmail = buildBrandingEmail;
exports.BUSINESS_UNIT_PUBLIC_APP_URL = {
    FR: 'https://app.iziwork.com',
    IT: 'https://app.iziwork.com',
    PM: 'https://app.interim.proman-solutions.fr',
    PSTF: 'https://app.promanstaffing.com',
};
exports.BUSINESS_UNIT_JOBS_URL = {
    FR: 'https://jobs.iziwork.com/fr',
    IT: 'https://jobs.iziwork.com/it',
    PM: 'https://jobs.interim.proman-solutions.fr/pm',
    PSTF: 'https://www.promanstaffing.com/jobs',
};
